document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initFaq();
  initGaleriaProducto();
  initVariantes();
  initCantidad();
  initCifras();
  initTilt();
});

/* Inclinacion 3D sutil en tarjetas al mover el cursor */
function initTilt() {
  var tarjetas = document.querySelectorAll('.lm-beneficio-card');
  if (!tarjetas.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (window.matchMedia('(hover: none)').matches) return;
  tarjetas.forEach(function (card) {
    card.addEventListener('mousemove', function (e) {
      var rect = card.getBoundingClientRect();
      var x = (e.clientX - rect.left) / rect.width - 0.5;
      var y = (e.clientY - rect.top) / rect.height - 0.5;
      card.style.setProperty('--lm-tilt-x', (x * 6).toFixed(2) + 'deg');
      card.style.setProperty('--lm-tilt-y', (y * -6).toFixed(2) + 'deg');
    });
    card.addEventListener('mouseleave', function () {
      card.style.setProperty('--lm-tilt-x', '0deg');
      card.style.setProperty('--lm-tilt-y', '0deg');
    });
  });
}

/* Reveal al hacer scroll (un solo observer compartido) */
function initReveal() {
  var els = document.querySelectorAll('.lm-reveal');
  if (!els.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    els.forEach(function (el) { el.classList.add('lm-visible'); });
    return;
  }
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('lm-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });
  els.forEach(function (el) { observer.observe(el); });
}

/* Acordeon de preguntas frecuentes */
function initFaq() {
  var items = document.querySelectorAll('.lm-faq-item');
  if (!items.length) return;
  items.forEach(function (item) {
    var boton = item.querySelector('.lm-faq-pregunta');
    var respuesta = item.querySelector('.lm-faq-respuesta');
    if (!boton || !respuesta) return;
    boton.addEventListener('click', function () {
      var abierto = item.getAttribute('data-abierto') === 'true';
      items.forEach(function (otro) {
        otro.setAttribute('data-abierto', 'false');
        var r = otro.querySelector('.lm-faq-respuesta');
        if (r) r.style.maxHeight = null;
      });
      if (!abierto) {
        item.setAttribute('data-abierto', 'true');
        respuesta.style.maxHeight = respuesta.scrollHeight + 40 + 'px';
      }
    });
  });
}

/* Galeria de la pagina de producto: cambia la imagen principal.
   Si la miniatura pertenece al grupo de otro kit, primero selecciona ese kit. */
function initGaleriaProducto() {
  var miniaturas = document.querySelectorAll('.lm-producto__miniatura');
  var principal = document.querySelector('.lm-producto__imagen-principal img');
  if (!miniaturas.length || !principal) return;
  miniaturas.forEach(function (mini) {
    mini.addEventListener('click', function () {
      var full = mini.getAttribute('data-full');
      if (!full) return;
      var grupo = mini.closest('.lm-producto__grupo');
      if (grupo && !grupo.classList.contains('lm-activo')) {
        var kit = grupo.getAttribute('data-kit');
        document.querySelectorAll('.lm-producto__valor').forEach(function (b) {
          if (b.getAttribute('data-valor') === kit) b.click();
        });
      }
      principal.src = full;
      miniaturas.forEach(function (m) { m.classList.remove('lm-activa'); });
      mini.classList.add('lm-activa');
    });
  });
}

/* Selector de variantes: actualiza precio, id oculto, estado agotado y grupo de fotos del kit */
function initVariantes() {
  var wrap = document.querySelector('[data-lm-producto]');
  if (!wrap) return;
  var dataEl = wrap.querySelector('[data-lm-variantes-json]');
  if (!dataEl) return;
  var variantes;
  try { variantes = JSON.parse(dataEl.textContent); } catch (e) { return; }

  var valores = wrap.querySelectorAll('.lm-producto__valor');
  var inputId = wrap.querySelector('input[name="id"]');
  var precioActual = wrap.querySelector('.lm-producto__precio-actual');
  var precioAnterior = wrap.querySelector('.lm-producto__precio-anterior');
  var botonComprar = wrap.querySelector('.lm-producto__comprar');
  var imagenPrincipal = wrap.querySelector('.lm-producto__imagen-principal img');
  var miniaturas = wrap.querySelectorAll('.lm-producto__miniatura');
  var grupos = wrap.querySelectorAll('.lm-producto__grupo');
  var seleccion = {};

  /* Semilla inicial a partir de la variante ya seleccionada en el servidor */
  if (inputId) {
    var varianteInicial = variantes.find(function (v) { return String(v.id) === String(inputId.value); });
    if (varianteInicial) {
      varianteInicial.nombres.forEach(function (nombre, i) { seleccion[nombre] = varianteInicial.opciones[i]; });
    }
  }

  wrap.querySelectorAll('.lm-producto__opciones[data-opcion]').forEach(function (grupo) {
    var activo = grupo.querySelector('.lm-producto__valor.lm-seleccionado');
    if (activo) seleccion[grupo.getAttribute('data-opcion')] = activo.getAttribute('data-valor');
  });

  function actualizar() {
    var variante = variantes.find(function (v) {
      return v.opciones.every(function (val, i) { return seleccion[v.nombres[i]] === val; });
    });
    if (!variante) return;
    if (inputId) inputId.value = variante.id;
    /* Texto de precio ya formateado por Shopify (p. ej. "$139"), en el formato de la moneda de la tienda */
    if (precioActual && variante.precioTexto) precioActual.textContent = variante.precioTexto;
    if (precioAnterior) {
      if (variante.precioComparado && variante.precioComparado > variante.precio) {
        precioAnterior.style.display = '';
        precioAnterior.textContent = variante.precioComparadoTexto;
      } else {
        precioAnterior.style.display = 'none';
      }
    }
    if (botonComprar) {
      botonComprar.disabled = !variante.disponible;
      botonComprar.textContent = variante.disponible ? botonComprar.getAttribute('data-texto-comprar') : botonComprar.getAttribute('data-texto-agotado');
    }
    grupos.forEach(function (g) {
      g.classList.toggle('lm-activo', g.getAttribute('data-kit') === seleccion['Kit']);
    });
    if (variante.imagen && imagenPrincipal && imagenPrincipal.src !== variante.imagen) {
      imagenPrincipal.src = variante.imagen;
      var coincide = false;
      miniaturas.forEach(function (m) {
        var esEsta = m.getAttribute('data-full') === variante.imagen;
        m.classList.toggle('lm-activa', esEsta);
        if (esEsta) coincide = true;
      });
      if (!coincide) miniaturas.forEach(function (m) { m.classList.remove('lm-activa'); });
    }
  }

  valores.forEach(function (boton) {
    boton.addEventListener('click', function () {
      var grupo = boton.closest('.lm-producto__opciones');
      var opcion = grupo.getAttribute('data-opcion');
      seleccion[opcion] = boton.getAttribute('data-valor');
      grupo.querySelectorAll('.lm-producto__valor').forEach(function (b) { b.classList.remove('lm-seleccionado'); });
      boton.classList.add('lm-seleccionado');
      actualizar();
    });
  });

  actualizar();
}

/* Selector de cantidad +/- */
function initCantidad() {
  document.querySelectorAll('.lm-producto__cantidad').forEach(function (caja) {
    var input = caja.querySelector('input');
    var menos = caja.querySelector('[data-menos]');
    var mas = caja.querySelector('[data-mas]');
    if (!input) return;
    if (menos) menos.addEventListener('click', function () {
      input.value = Math.max(1, parseInt(input.value || '1', 10) - 1);
    });
    if (mas) mas.addEventListener('click', function () {
      input.value = parseInt(input.value || '1', 10) + 1;
    });
  });
}

/* Cifras animadas (count-up al entrar en pantalla) */
function initCifras() {
  var cifras = document.querySelectorAll('.lm-cifra__numero[data-hasta]');
  if (!cifras.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      var hasta = parseFloat(el.getAttribute('data-hasta'));
      var sufijo = el.getAttribute('data-sufijo') || '';
      var duracion = 1400;
      var inicio = null;
      function paso(ts) {
        if (!inicio) inicio = ts;
        var progreso = Math.min((ts - inicio) / duracion, 1);
        var valor = Math.floor(progreso * hasta);
        el.textContent = valor + sufijo;
        if (progreso < 1) requestAnimationFrame(paso);
        else el.textContent = hasta + sufijo;
      }
      requestAnimationFrame(paso);
      observer.unobserve(el);
    });
  }, { threshold: 0.5 });
  cifras.forEach(function (el) { observer.observe(el); });
}
